module.exports = __webpack_public_path__ + "static/media/republic-of-macedonia.6f3cf353.svg";